<template>
    <div class="display-block">
        <h3>Brand</h3>
        <v-card>
            <v-card-text>
                <h3>Brand :</h3>
                <row-item label="Title  " :value="brand.title"></row-item>
            </v-card-text>
                <v-flex text-right><v-btn @click="$router.go(-1)" class="ma-2" :style="theme">Back</v-btn></v-flex>
        </v-card>
    </div>
</template>

<script>
import appConstants from '@/utils/appConstants'
import axios from "axios";
import RowItem from '@/components/RowItem'
export default {
    components: {
        RowItem,
    },
    data() {
        return {
            id:0,
            items:[],
            brand: {
                id: "",
                title: ""
            },
        }
    },
    mounted() {
        this.initComponent();
    },
    methods: {
        async initComponent() {
            this.id = this.$route.params.id
                this.brand = await this.getItem(appConstants.BRANDS_API + "/" + this.id)
        },
    }
}
</script>
